module.exports = __webpack_public_path__ + "static/media/web_txfr.1902f81b.ico";